import React, {createContext, useCallback, useContext, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useEventContext} from "./EventContext";
import {usePlayerContext} from "./PlayerContext";
import {generateUniqueId} from "../utils/generateUniqueId";
import Notifications from "../components/Notifications";

export const NotificationsContext = createContext(null);

export const useNotificationsContext = () => useContext(NotificationsContext);

export const NotificationsContextProvider = ({children}) => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {watchKey} = useEventContext();
    const {tabletView, isFloating} = usePlayerContext();
    const [messages, setMessages] = useState([]);
    const [isShowPlayer, setIsShowPlayer] = useState(false);
    
    const [, , , pageName] = pathname.split('/');

    const handleMessage = useCallback((messageId) => {
        const message = messages.find(({id}) => id === messageId);
        if (message.buttonRoute !== undefined && (!message.pagesIsNotRoute || !message.pagesIsNotRoute.includes(pageName))) {
            navigate(`/event/${watchKey}${message.buttonRoute}`);
        }

        if (message.callback) {
            message.callback();
        }

        onCloseMessage(message.id);
    }, [pageName, messages, watchKey]);

    const onCloseMessage = useCallback((messageId) => {
        setMessages((messages) => messages.filter((item) => item.id !== messageId));
    }, []);

    const addMessage = useCallback(({id, title, buttonTitle, callback, buttonRoute, pagesIsNotRoute}) => {
        const message = {
            id: id ?? generateUniqueId(),
            buttonTitle: buttonTitle,
            callback: callback,
            title: title,
            buttonRoute: buttonRoute,
            pagesIsNotRoute: pagesIsNotRoute,
        };

        setMessages(prevMessages => [...prevMessages, message]);
    }, []);

    const context = {
        messages,
        handleMessage,
        onCloseMessage,
        addMessage,
        setIsShowPlayer,
    };

    return (
        <NotificationsContext.Provider value={context}>
            {(tabletView || !isShowPlayer || isFloating) ? <Notifications /> : null}
            {children}
        </NotificationsContext.Provider>
    );
}
